import classNames from "classnames";
import Link from "@/components/UI/Link/Link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import Image from "next/image";

interface Section07Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const UseCasesSection = ({ job, page, section, ...props }: Section07Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <div
          className={classNames("flex gap-10", {
            "flex-row-reverse": section?.Orientation === "End",
          })}
        >
          {section?.Image?.data?.attributes && (
            <div className="hidden shrink-0 xl:block">
              <Image
                alt={section?.Image?.data?.attributes?.alternativeText}
                src={section?.Image?.data?.attributes?.url}
                height={section?.Image?.data?.attributes?.height ?? "100"}
                width={section?.Image?.data?.attributes?.width ?? "100"}
              />
            </div>
          )}
          {section?.FeatureBlocks && (
            <div className="flex flex-col justify-center gap-20">
              <SectionHeader section={section} />
              <div className="grid grid-cols-1 items-start gap-10 md:grid-cols-2">
                {section?.FeatureBlocks?.map((block: any) => {
                  return (
                    <div className="flex gap-6" key={block?.id}>
                      {block?.Icon?.data?.attributes && (
                        <div
                          className={classNames(
                            "flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-xl",
                            block?.IconContainerClassName
                          )}
                          style={block?.IconContainerStyle}
                        >
                          <div
                            className={classNames("h-6 w-6", block?.IconClassName)}
                            style={{
                              mask: `url(${block?.Icon?.data?.attributes?.url}) no-repeat center / contain`,
                              WebkitMask: `url(${block?.Icon?.data?.attributes?.url}) no-repeat center / contain`,
                              ...block?.IconStyle,
                            }}
                          />
                        </div>
                      )}
                      <div className="flex flex-col gap-4 lg:w-2/3">
                        <div className="flex flex-col gap-2">
                          {block?.Overline && (
                            <div className="text-xs font-bold text-vpGray-600">{block?.Overline}</div>
                          )}
                          <div className="font-bold">{block?.Title}</div>
                        </div>
                        <div className="text-vpGray-700">{block?.Body}</div>
                        {block?.LinkUrl && block?.LinkValue && (
                          <Link className="flex items-center gap-2" href={block?.LinkUrl} variant="external">
                            {block?.LinkValue}
                            <FontAwesomeIcon icon={faArrowRight} />
                          </Link>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </SectionContainer>
    </Section>
  );
};

export default UseCasesSection;
